import * as URL from '@/config/urlconfig';
export default{
  data() {
    return {
      ...URL
    };
  },
  methods: {
    itemshow(item, index) {
      if (this.oldcengindex === 0 || this.oldcengindex) {
        this.pageList[this.oldcengindex].cengshow = false;
      }
      item.cengshow = true;
      this.oldcengindex = index;
    },
    seeImage(imgsrc) {
      const parma = {
        visible: true,
        src: imgsrc
      };
      this.$store.commit('setimgprivewData', parma);
    },
    openConfirm(title, desc) {
      return new Promise((resolve, reject) => {
        this.$confirm(desc, title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          resolve(true);
        }).catch(() => {
          resolve(false);
        });
      });
    },
    openInputBox(title, desc, defaultValue, reg, errtext) {
      return new Promise((resolve, reject) => {
        this.$prompt(desc, title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: reg || /\S/,
          closeOnClickModal: false,
          inputValue: defaultValue || '',
          inputErrorMessage: errtext || '请填写'
        }).then(({ value }) => {
          resolve(value);
        }).catch(() => {
          resolve(false);
        });
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/mixin.js